// components/protectedRoutes/protectedRoutes.component.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import LoadingPage from "../retro/loading-page/loading-page.component";

function ProtectedRoutes({
  authReady,
  firebaseUser,
  isAuth,
  needsBirthday,
}) {
  const location = useLocation();

  if (!authReady) return <LoadingPage />;

  if (!firebaseUser) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (!firebaseUser.emailVerified) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  if (needsBirthday) {
    return (
      <Navigate to="/complete-profile" state={{ from: location }} replace />
    );
  }

  // Firebase Auth and the private profile are ready, but the public Firestore
  // profile may still be resolving during a transient retry.
  if (!isAuth) return <LoadingPage />;

  return <Outlet />;
}

export default ProtectedRoutes;
